import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import object1 from "./components/object-1";
import object2 from "./components/object-2";
import object3 from "./components/object-3";
import fullMix from "./components/full-mix";

const principle: Slide = {
  description:
    "Use headphones to listen to three samples containing isolated audio objects (1 - 3) that have been binaural rendered. You can compare each object with its raw sound essence (stereo track). “Full mix” presents the final mix of all three objects supplemented with other objects (the second part of the recording). The attached video visualizes the position and movement of objects in a virtual room.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "button",
          options: {},
          items: [
            { name: "Object 1 (static)" },
            { name: "Object 2 (dynamic)" },
            { name: "Object 3 (dynamic)" },
            { name: "Full mix" },
          ],
        },
      ],
      controlsPosition: "top",
      extraContent: [[], [], [], []],
      components: [object1, object2, object3, fullMix],
    },
  },
};

export default principle;
